module.exports = __webpack_public_path__ + "img/round-table-white.5fb21e54.svg";